import { withTheme } from '@digital-retail/falabella-ui-cross-components';
import { cx } from 'cvb';
import PropTypes from 'prop-types';
import React from 'react';
import constants from '../../../../../config/constants';
import { capitalizeString } from '../../../../../utils/jsUtils';
import _ from '../../../../../utils/LodashImports';
import { noop } from '../../../../../utils/noop';
import { withProduct } from '../../../../../utils/ProductContext';
import { getUnits } from '../../utils';
import StoreListDetailsStyles from './StoreListDetails.style';

const StoreListDetails = ({
  type,
  storeData,
  setSelectedStoreId,
  selectedStoreId,
  textDictionary,
  theme,
  view,
  product,
  isStockInStoreFlow,
  endpoints,
  deviceType,
  saveSelectedStoreOption,
}) => {
  const themedStoresListStyles = StoreListDetailsStyles(theme);
  const { stockCategoryConfig, stockCategoryLimit } = product;
  const CHECK_SCHEDULE = _.get(textDictionary, 'CHECK_SCHEDULE', 'Revisar Horarios');
  const workingHours = {
    falabella: _.get(endpoints, 'WORKING_HOURS_TIENDA', ''),
    sodimac: _.get(endpoints, 'WORKING_HOURS_SODIMAC', ''),
    tottus: _.get(endpoints, 'WORKING_HOURS_TOTTUS', ''),
  };
  const isListView = view === 'list';

  const handleClick = (storeId) => {
    setSelectedStoreId((prev) => ({ ...prev, [type]: storeId }));
    if (deviceType === 'mobile') {
      saveSelectedStoreOption();
    }
  };

  return (
    <div className={cx('lists-container', isListView && 'list-view')}>
      <div className={cx('store-box', isListView && 'list-view')}>
        {storeData[type].map((d) => {
          const addressLine1 = _.get(d, 'address.addressLine1', '');
          const municipalName = _.get(d, 'address.municipalName', '');
          const operator = _.get(d, 'operator', 'falabella').toLowerCase();
          const workingDays = _.get(d, 'workingDays', '');
          const storeId = _.get(d, 'storeId' || 'id', '');
          const dateLabel = _.get(textDictionary, 'DATE_LABEL', 'Desde el <<date>> de <<month>>');
          const freeLabel = _.get(textDictionary, 'FREE_LABEL', 'Gratis');
          const openLabel = _.get(textDictionary, 'OPEN_LABEL', 'Abierto');
          const date = _.get(d, 'earliestAvailableSlot.slotDate.date', '');
          const month = _.get(d, 'earliestAvailableSlot.slotDate.month', '');
          const cost = _.get(d, 'earliestAvailableSlot.cost', '');
          const costLabel = constants.FREE_PICKUP_PRICE.test(cost) ? freeLabel : cost;
          const replacedDateLabel = dateLabel.replace('<<date>>', date).replace('<<month>>', month);
          let classUnits = '';
          let textUnits = '';

          if (isStockInStoreFlow && d.stockQuantity) {
            const { number } = d.stockQuantity;
            classUnits = number <= stockCategoryLimit ? 'not-available' : 'available';
            textUnits = getUnits(number, stockCategoryConfig, stockCategoryLimit, textDictionary);
          }

          return (
            <React.Fragment key={`testId-${storeId}`}>
              <div
                id={`testId-${storeId}`}
                role="button"
                tabIndex={0}
                onKeyDown={noop}
                onClick={() => handleClick(storeId)}
                className={cx('details-container', selectedStoreId[type] === storeId && 'selected')}
              >
                <input
                  type="radio"
                  readOnly
                  className="selection-radio"
                  id="delivery-options-selection"
                  checked={selectedStoreId[type] === storeId}
                />
                <div
                  className={cx(
                    'store-content',
                    isListView && 'list-view',
                    selectedStoreId[type] === storeId && 'selected'
                  )}
                >
                  <div className="name-address">
                    <div className="store-name">
                      <p>{capitalizeString(d.storeName)}</p>
                      <p>
                        {capitalizeString(addressLine1)}, {capitalizeString(municipalName)}
                      </p>
                      {isStockInStoreFlow && (
                        <a
                          href={workingHours[operator]}
                          target="_blank"
                          className="check-store-schedules"
                          rel="noreferrer"
                        >
                          {CHECK_SCHEDULE}
                        </a>
                      )}
                    </div>
                    <span className={`icon ${operator}`} />
                  </div>
                  {workingDays && (
                    <div className="working-hours flex">
                      <span className="icon clock-icon" />
                      <span className="cost-label green-bold">{openLabel}</span>
                      <p className="working-text">{workingDays}</p>
                    </div>
                  )}
                  {replacedDateLabel && costLabel && (
                    <div className="delivery-dates flex">
                      <p>{replacedDateLabel}</p>
                      <p className={cx('cost-label', costLabel === freeLabel && 'green-bold')}>{costLabel}</p>
                    </div>
                  )}
                  {isStockInStoreFlow && d.stockQuantity && (
                    <p className={`store-availability ${classUnits}`}>{textUnits}</p>
                  )}
                </div>
              </div>
              <div className="separator" />
            </React.Fragment>
          );
        })}
      </div>
      <style jsx>{themedStoresListStyles}</style>
    </div>
  );
};
StoreListDetails.propTypes = {
  type: PropTypes.string.isRequired,
  storeData: PropTypes.object,
  setSelectedStoreId: PropTypes.func.isRequired,
  selectedStoreId: PropTypes.object.isRequired,
  textDictionary: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  view: PropTypes.string.isRequired,
  product: PropTypes.object.isRequired,
  isStockInStoreFlow: PropTypes.bool,
  endpoints: PropTypes.object.isRequired,
  deviceType: PropTypes.string.isRequired,
  saveSelectedStoreOption: PropTypes.func.isRequired,
};

StoreListDetails.defaultProps = {
  storeData: {},
  isStockInStoreFlow: false,
};

export default withTheme(withProduct(StoreListDetails));
export { StoreListDetails };
